/* Variant File metafields, rendered by Liquid. Only the chosen view loads at full size. */
(function () {
  'use strict';
  var normalize = function (value) { return String(value || '').trim().toLowerCase().replace(/[ _]+/g, '-'); };
  var selectionKey = function (s) { return [s.kit, s.materialLabel, s.cutout].map(normalize).join('|'); };

  function imageURL(source, width, storefront) {
    var url = new URL(source);
    var shopCDN = storefront && typeof window !== 'undefined' && url.origin === window.location.origin && url.pathname.indexOf('/cdn/shop/') === 0;
    if (url.protocol !== 'https:' || (url.hostname !== 'cdn.shopify.com' && !shopCDN)) throw new Error('Unsupported image source');
    url.searchParams.set('width', String(Math.round(width)));
    return url.href;
  }

  function validate(data, productId) {
    if (!data || String(data.productId) !== String(productId) || !data.variants || typeof data.variants !== 'object' || Array.isArray(data.variants)) throw new Error('Invalid variant gallery data');
    return data;
  }

  function FileGallery(root) {
    this.root = root;
    this.picture = root.querySelector('[data-gallery-picture]');
    this.thumbs = root.querySelector('[data-gallery-thumbs]');
    this.caption = root.querySelector('[data-gallery-caption]');
    this.message = root.querySelector('[data-gallery-message]');
    this.messageText = root.querySelector('[data-gallery-message-text]');
    this.retry = root.querySelector('[data-gallery-retry]');
    this.status = root.querySelector('[data-gallery-status]');
    this.navigation = root.querySelector('[data-gallery-navigation]');
    this.prev = root.querySelector('[data-gallery-prev]');
    this.next = root.querySelector('[data-gallery-next]');
    this.enlarge = root.querySelector('[data-gallery-enlarge]');
    this.dialog = root.querySelector('[data-gallery-dialog]');
    this.zoom = root.querySelector('[data-gallery-zoom]');
    this.zoomToggle = root.querySelector('[data-gallery-zoom-toggle]');
    this.views = [];
    this.index = 0;
    this.sequence = 0;
    this.selection = {};
    this.key = null;
    this.standard = root.dataset.galleryMode === 'standard';
    if (this.standard) {
      var nativeData = JSON.parse(root.querySelector('[data-gallery-native-variants]').textContent);
      this.nativeVariants = nativeData.variants;
      this.productMain = nativeData.productMain;
      this.nativeSelected = this.nativeVariants.find(function (v) { return String(v.id) === String(nativeData.selected); });
    }
    this.bind();
    this.setPending('Select a material to preview it here.', false);
    if (this.standard) this.syncStandard();
    else this.syncFromWizard();
  }

  FileGallery.prototype.setPending = function (text, retry) {
    this.root.classList.add('is-pending');
    this.root.dataset.galleryState = retry ? 'error' : 'pending';
    this.picture.disabled = true;
    this.displayedRecord = null;
    this.message.hidden = false;
    this.messageText.textContent = text;
    this.retry.hidden = !retry;
    this.enlarge.hidden = true;
    this.status.textContent = text;
    this.root.setAttribute('aria-busy', text === 'Loading preview...' ? 'true' : 'false');
  };

  FileGallery.prototype.variantViews = function () {
    var variant = this.selectedVariant();
    var main = this.fallbackRecord();
    if (!variant || !main) throw new Error('No exact variant main');
    if (!this.variantData) {
      var source = this.root.querySelector('[data-gallery-variants]');
      this.variantData = validate(JSON.parse(source.textContent), this.root.dataset.productId);
    }
    if (!Object.prototype.hasOwnProperty.call(this.variantData.variants, String(variant.id))) throw new Error('Variant gallery data is incomplete');
    var extras = this.variantData.variants[String(variant.id)];
    if (!Array.isArray(extras)) throw new Error('Invalid additional images');
    var views = [{view: 'main', label: 'Main image', record: main}];
    // The same file can have a cdn.shopify.com or /cdn/shop/ URL. Ignore sizing
    // parameters when excluding a repeated main or duplicate extra reference.
    var fileName = function (src) { return new URL(src).pathname.split('/').pop(); };
    var seen = new Set([fileName(main.src)]);
    extras.forEach(function (extra) {
      var record = {src: String(extra.src || '').replace(/^\/\//, 'https://'),
        width: extra.width, height: extra.height, alt: extra.alt || main.alt, storefront: true};
      if (!(record.width > 0 && record.height > 0)) throw new Error('Invalid additional image');
      imageURL(record.src, 100, true);
      var name = fileName(record.src);
      if (seen.has(name)) return;
      seen.add(name);
      views.push({view: 'additional-' + views.length, label: 'Image ' + (views.length + 1), record: record});
    });
    return views;
  };

  FileGallery.prototype.syncFromWizard = function () {
    if (this.standard) return;
    var wiz = window.WIZ;
    if (wiz) this.select({ kit: wiz.selectedKit, cutout: wiz.selectedLogo, materialLabel: wiz.selectedMaterial && wiz.selectedMaterial.label });
  };

  FileGallery.prototype.syncStandard = function () {
    if (!this.nativeSelected) return;
    this.select({kit: String(this.nativeSelected.id), materialLabel: this.nativeSelected.title || 'Product image', cutout: ''});
  };

  // The wizard's existing variant data supplies the assigned main image.
  // Never borrow a different material/kit's main image when a lookup fails.
  FileGallery.prototype.selectedVariant = function () {
    if (this.standard) return this.nativeSelected;
    var wiz = window.WIZ;
    var selection = this.selection;
    if (!wiz || !wiz.hasMaterialVariant || !wiz.materialOptionPosition || !wiz.kitOptionPosition) return null;
    var matches = (wiz.variants || []).filter(function (variant) {
      return normalize(variant['option' + wiz.kitOptionPosition]) === normalize(selection.kit) &&
        normalize(variant['option' + wiz.materialOptionPosition]) === normalize(selection.materialLabel) &&
        (!wiz.logoOptionPosition || normalize(variant['option' + wiz.logoOptionPosition]) === normalize(selection.cutout));
    });
    return matches.length === 1 ? matches[0] : null;
  };

  FileGallery.prototype.fallbackRecord = function () {
    var variant = this.selectedVariant();
    if (!variant) return null;
    var image = variant.featured_image || (this.standard && this.productMain);
    if (!image) return null;
    if (!(image.width > 0 && image.height > 0)) return null;
    var src = String(image.src || '').replace(/^\/\//, 'https://');
    try { imageURL(src, 600, true); } catch (_) { return null; }
    return {src: src, width: image.width, height: image.height, storefront: true,
      alt: image.alt || this.selection.materialLabel.replace(/-/g, ' ') + ' · ' + this.selection.kit + ' · main product image'};
  };

  FileGallery.prototype.showFallback = async function (sequence) {
    if (sequence !== this.sequence) return;
    this.navigation.hidden = true;
    this.thumbs.replaceChildren();
    var record = this.fallbackRecord();
    this.setPending('Additional previews are unavailable. Please try again.', true);
    if (!record) return;
    try {
      var img = await this.loadImage(record);
      if (sequence !== this.sequence) return;
      this.picture.replaceChildren(img);
      this.picture.disabled = false;
      this.displayedRecord = record;
      this.root.classList.remove('is-pending');
      this.root.setAttribute('aria-busy', 'false');
      this.root.dataset.galleryState = 'fallback';
      this.root.dataset.galleryView = 'variant-main';
      this.enlarge.hidden = false;
      this.status.textContent = 'Main product image. Additional previews are unavailable.';
    } catch (_) {
      if (sequence === this.sequence) this.setPending('This image could not load. Please try again.', true);
    }
  };

  FileGallery.prototype.loadImage = async function (record) {
    var img = new Image();
    img.className = 'm2-file-gallery__image';
    img.width = record.width; img.height = record.height; img.alt = record.alt;
    img.decoding = 'async';
    var width = Math.min(record.width, 1600, Math.max(600, Math.ceil((this.picture.clientWidth || 600) * Math.min(window.devicePixelRatio || 1, 2))));
    var timer;
    try {
      await new Promise(function (resolve, reject) {
        timer = setTimeout(function () { reject(new Error('Image timeout')); }, 15000);
        img.onload = resolve; img.onerror = reject;
        img.src = imageURL(record.src, width, record.storefront);
      });
      if (img.decode) await img.decode();
      return img;
    } finally {
      clearTimeout(timer);
      img.onload = img.onerror = null;
    }
  };

  FileGallery.prototype.select = async function (selection, force) {
    var key = selectionKey(selection);
    if (!force && key === this.key) return;
    this.key = key;
    var previousView = this.selection.kit === selection.kit && this.views[this.index] && this.views[this.index].view;
    this.selection = selection;
    var sequence = ++this.sequence;
    if (this.dialog.open) this.dialog.close();
    this.navigation.hidden = true;
    if (!selection.kit || !selection.materialLabel || (!this.standard && this.root.dataset.requiresCutout !== 'false' && !selection.cutout)) {
      this.setPending('Select a material to preview it here.', false);
      return;
    }
    if (this.selectedVariant() && !this.fallbackRecord()) {
      this.views = [];
      this.thumbs.replaceChildren();
      this.setPending('Preview images are not available for this option.', false);
      this.root.dataset.galleryState = 'unavailable';
      return;
    }
    this.setPending('Loading preview...', false);
    this.caption.textContent = this.standard ? 'Product image' : 'Studio render · ' + selection.materialLabel.replace(/-/g, ' ') + ' · ' + selection.kit + ' Kit';
    try {
      this.views = this.variantViews();
      this.index = Math.max(0, this.views.findIndex(function (view) { return view.view === previousView; }));
      this.buildThumbs();
      this.show(this.index);
    } catch (error) {
      if (sequence === this.sequence) this.showFallback(sequence);
    }
  };

  FileGallery.prototype.buildThumbs = function () {
    var self = this;
    this.thumbs.replaceChildren();
    this.views.forEach(function (view, index) {
      var record = view.record;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'm2-file-gallery__thumb';
      button.setAttribute('aria-label', view.label);
      button.title = view.label;
      var img = document.createElement('img');
      img.width = 66; img.height = 66; img.alt = '';
      img.src = imageURL(record.src, Math.min(160, record.width), record.storefront);
      button.appendChild(img);
      button.addEventListener('click', function () { self.show(index); });
      self.thumbs.appendChild(button);
    });
    this.navigation.hidden = this.views.length < 2;
  };

  FileGallery.prototype.show = async function (index) {
    if (!this.views[index]) return;
    this.index = index;
    var sequence = ++this.sequence;
    var view = this.views[index];
    var record = view.record;
    this.setPending('Loading preview...', false);
    Array.from(this.thumbs.children).forEach(function (thumb, i) { thumb.setAttribute('aria-current', String(i === index)); });
    this.prev.disabled = index === 0;
    this.next.disabled = index === this.views.length - 1;
    try {
      var img = await this.loadImage(record);
      if (sequence !== this.sequence) return;
      this.picture.replaceChildren(img);
      this.picture.disabled = false;
      this.displayedRecord = record;
      this.root.classList.remove('is-pending');
      this.root.setAttribute('aria-busy', 'false');
      this.root.dataset.galleryState = 'ready';
      this.root.dataset.galleryView = view.view;
      this.message.hidden = true;
      this.enlarge.hidden = false;
      this.status.textContent = view.label + ', image ' + (index + 1) + ' of ' + this.views.length;
    } catch (error) {
      if (sequence === this.sequence) this.showFallback(sequence);
    }
  };

  FileGallery.prototype.openZoom = function () {
    if (this.root.classList.contains('is-pending') || !this.displayedRecord) return;
    var record = this.displayedRecord;
    var width = Math.min(2400, record.width);
    var height = Math.round(width * record.height / record.width);
    this.zoom.src = imageURL(record.src, width, record.storefront);
    this.zoom.alt = record.alt;
    this.zoom.width = width; this.zoom.height = height;
    this.dialog.style.setProperty('--image-width', width + 'px');
    this.dialog.style.setProperty('--image-height', height + 'px');
    this.dialog.classList.remove('is-actual-size');
    this.zoomToggle.textContent = 'Actual size';
    this.root.querySelector('[data-gallery-zoom-label]').textContent = this.caption.textContent;
    this.dialog.showModal();
  };

  FileGallery.prototype.bind = function () {
    var self = this;
    this.onSummary = function (event) { if (!self.standard) self.select(event.detail || {}); };
    document.addEventListener('wizard:summary', this.onSummary);
    this.onNativeVariant = function (event) {
      if (!self.standard || !event.detail || !event.detail.variant) return;
      var selected = self.nativeVariants.find(function (v) { return String(v.id) === String(event.detail.variant.id); });
      if (selected) { self.nativeSelected = selected; self.syncStandard(); }
    };
    document.addEventListener('variant:change', this.onNativeVariant);
    this.prev.addEventListener('click', function () { self.show(self.index - 1); });
    this.next.addEventListener('click', function () { self.show(self.index + 1); });
    this.retry.addEventListener('click', function () { self.select(self.selection, true); });
    this.picture.addEventListener('click', function () { if (!self.swiped) self.openZoom(); self.swiped = false; });
    this.enlarge.addEventListener('click', function () { self.openZoom(); });
    this.root.querySelector('[data-gallery-close]').addEventListener('click', function () { self.dialog.close(); });
    this.zoomToggle.addEventListener('click', function () {
      self.zoomToggle.textContent = self.dialog.classList.toggle('is-actual-size') ? 'Fit image' : 'Actual size';
    });
    this.root.addEventListener('keydown', function (event) {
      if (self.dialog.open || self.root.dataset.galleryState !== 'ready') return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault(); self.show(self.index + (event.key === 'ArrowLeft' ? -1 : 1));
      }
    });
    var start;
    this.picture.addEventListener('pointerdown', function (event) {
      self.swiped = false;
      start = event.pointerType === 'touch' ? { x: event.clientX, y: event.clientY } : null;
    });
    this.picture.addEventListener('pointerup', function (event) {
      if (!start) return;
      var x = event.clientX - start.x, y = event.clientY - start.y;
      start = null;
      if (self.root.dataset.galleryState === 'ready' && Math.abs(x) > 45 && Math.abs(x) > Math.abs(y) * 1.5) {
        self.swiped = true; self.show(self.index + (x < 0 ? 1 : -1));
      }
    });
    this.picture.addEventListener('pointercancel', function () { start = null; });
  };

  function init(scope) {
    scope.querySelectorAll('[data-m2-file-gallery]').forEach(function (root) {
      if (!root._fileGallery) root._fileGallery = new FileGallery(root);
    });
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { validate: validate, selectionKey: selectionKey, imageURL: imageURL };
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('[data-m2-file-gallery]').forEach(function (root) {
        if (root._fileGallery) { root._fileGallery.sequence++; document.removeEventListener('wizard:summary', root._fileGallery.onSummary); document.removeEventListener('variant:change', root._fileGallery.onNativeVariant); }
      });
    });
  }
})();
